<template>
    <module-card>
        <p>
            We’re going to focus again on the steps to putting on a condom, since condoms are one of the best ways to prevent HIV during sex. You’ll be trying to answer each question
            <span class="font-weight-bold">as if you are under the influence of alcohol or other drugs.</span>
        </p>
        <p>
            Select the correct word to replace the bolded word. To replicate being under the influence, the screen will be blurry and it will be difficult to see what you are doing, just like it might be if you were really under the
            influence! Do your best to make the right choice in each slide – if you can even see what you’re doing!
        </p>
    </module-card>
</template>

<script>
    export default {
        mounted() {
            this.$store.set('rubberMishapIncorrect', []);
        }
    };
</script>
